import { indentformDto } from "@gtpl/shared-models/procurement-management";
import { Injectable } from "@nestjs/common";
import { IndentFormDto } from "./dto/indent-form-for-material.dto";
import { IndentMaterialEntity } from "./indent-form-entity";
import { IndentItemEntity } from "./indent-item-entity";


@Injectable()

export class IndentFormAdapterFormMaterial
{
    public convertDtoToEntity(indentFormDto:IndentFormDto, isUpdate: boolean = false ):IndentMaterialEntity{
      console.log(indentFormDto,'indentFormDto')
        const indententity = new IndentMaterialEntity();
        indententity.indentMaterialPreparationId=indentFormDto.indentMaterialPreparationId;
        indententity.indentDate=indentFormDto.indentDate;
        indententity.employeeId=indentFormDto.employeeId;
        indententity.indentAgainst=indentFormDto.indentAgainst;
        indententity.saleOrderItemId=indentFormDto.saleOrderItemId;
        indententity.saleOrderId=indentFormDto.saleOrderId;
        indententity.createdAt=indentFormDto.createdAt;
        indententity.createdUser=indentFormDto.createdUser;
        indententity.updatedAt=indentFormDto.updatedAt;
        indententity.versionFlag=indentFormDto.versionFlag;
        indententity.status=indentFormDto.status;
        indententity.unitId=indentFormDto.unitId;
        
        if (isUpdate) {
          indententity.updatedUser = indentFormDto.updatedUser;
        } else {
            indententity.indentCode=indentFormDto.indentCode;
            indententity.isActive = true;
            indententity.createdUser = indentFormDto.createdUser;
          }
          const conItems: IndentItemEntity[]  = []; 
          for (const indentitems of indentFormDto.indentItemDetails) {
              const itemsEntity: IndentItemEntity = new IndentItemEntity();
              if(!isUpdate){
                indententity.createdUser = indentFormDto.createdUser;
              }else{
                  itemsEntity.indentItemId =indentitems.indentItemId;
                  indententity.updatedUser = indentFormDto.updatedUser; 
              }
              itemsEntity.indentMaterialPreparationId =indentitems.indentMaterialPreparationId;
              itemsEntity.itemsubcategoryId =indentitems.itemsubcategoryId;
              itemsEntity.receivedQuantity =indentitems.receivedQuantity;
              itemsEntity.itemId=indentitems.itemId;
              itemsEntity.quantity=indentitems.quantity;
              itemsEntity.unitId=indentitems.unitId;
              conItems.push(itemsEntity);
          }
          indententity.indentItemDetails = conItems;
         return indententity;
    }
    public convertEntityToDto(indentObject: IndentMaterialEntity): IndentFormDto {
        const indentFormDto= new IndentFormDto;
        indentFormDto.indentMaterialPreparationId=indentObject.indentMaterialPreparationId;
        indentFormDto.indentDate=indentObject.indentDate;
        indentFormDto.employeeId=indentObject.employeeId;
        indentFormDto.indentAgainst=indentObject.indentAgainst;
        indentFormDto.saleOrderItemId=indentObject.saleOrderItemId;
        indentFormDto.createdAt=indentObject.createdAt;
        indentFormDto.createdUser=indentObject.createdUser;
        indentFormDto.updatedAt=indentObject.updatedAt;
        indentFormDto.updatedAt=indentObject.updatedAt;
        indentFormDto.updatedUser=indentObject.updatedUser;
        indentFormDto.versionFlag=indentObject.versionFlag;
        indentFormDto.isActive=indentObject.isActive;
        indentFormDto.status=indentObject.status;
        indentFormDto.indentCode=indentObject.indentCode;
        indentFormDto.unitId=indentObject.unitId;

        return indentFormDto;
      }
}
